/*
============================================================
ZB MODE — ASK A QUESTION
============================================================
*/

(function () {
  function initializeAskQuestion(root) {
    if (
      !root ||
      root.dataset.zbAskQuestionInitialized === 'true'
    ) {
      return;
    }

    root.dataset.zbAskQuestionInitialized = 'true';

    const openButton = root.querySelector(
      '[data-zb-ask-question-open]'
    );

    const dialog = root.querySelector(
      '[data-zb-ask-question-dialog]'
    );

    const closeButton = root.querySelector(
      '[data-zb-ask-question-close]'
    );

    const autoOpenState = root.querySelector(
      '[data-zb-ask-auto-open]'
    );

    const form = root.querySelector('form');

    const submitButton = root.querySelector(
      '[data-zb-ask-submit]'
    );

    const submitText = root.querySelector(
      '[data-zb-ask-submit-text]'
    );

    if (!openButton || !dialog) {
      return;
    }

    function openDialog() {
      if (dialog.open) {
        return;
      }

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    function closeDialog() {
      if (!dialog.open) {
        return;
      }

      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    openButton.addEventListener('click', openDialog);

    if (closeButton) {
      closeButton.addEventListener('click', closeDialog);
    }

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        closeDialog();
      }
    });

    dialog.addEventListener('close', function () {
      openButton.focus();
    });

    if (form && submitButton) {
      form.addEventListener('submit', function () {
        submitButton.disabled = true;

        if (submitText) {
          submitText.textContent = 'SENDING...';
        }
      });
    }

    if (autoOpenState) {
      window.requestAnimationFrame(openDialog);
    }
  }

  function initializeAllAskQuestions() {
    document
      .querySelectorAll('[data-zb-ask-question]')
      .forEach(initializeAskQuestion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllAskQuestions
    );
  } else {
    initializeAllAskQuestions();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeAllAskQuestions
  );
})();